import { render, staticRenderFns } from "./delivery-pick.vue?vue&type=template&id=994df848&scoped=true"
import script from "./delivery-pick.vue?vue&type=script&lang=js"
export * from "./delivery-pick.vue?vue&type=script&lang=js"
import style0 from "./delivery-pick.vue?vue&type=style&index=0&id=994df848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994df848",
  null
  
)

export default component.exports